import { useEffect } from 'react'

export function useVaultTypeFromQuery(
  type: string,
  setActiveFilter: (v: string) => void
) {
  useEffect(() => {
    switch (type) {
      case 'feed':
      case 'premium':
      case 'messages':
      case 'reels':
      case 'locked_messages':
      case 'mass_messages':
      case 'story':
      case 'all':
        setActiveFilter(type)
        break

      default:
        setActiveFilter('all')
    }
  }, [type, setActiveFilter])
}